import { Component, OnInit } from '@angular/core';
import { NewsletterFooterService } from '../../../services/newsletters/newsletter-footer.service';
import { ActivatedRoute } from '@angular/router';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-newsletter-footer-show',
  templateUrl: './newsletter-footer-show.component.html',
  styleUrls: ['./newsletter-footer-show.component.scss'],
})
export class NewsletterFooterShowComponent implements OnInit {
  name: string = '';
  htmlContent: string = '';

  constructor(private newsletterFooterService: NewsletterFooterService, private notyService: NotyService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.newsletterFooterService
      .show({ angular: true, newsletterFooterId: this.route.snapshot.params['id'] })
      .then((showRe) => {
        console.log('showRe', showRe);
        this.name = showRe.name;
        this.htmlContent = showRe.html_content;
        document.querySelector('#newletter-footer-preview')!.setAttribute('srcdoc', `<html><body>${this.htmlContent}</body></html>`);
      })
      .catch((showErr) => {
        console.log('show error', showErr);
      });
  }
}
